<template>
  <div ref="modalw" class="modal-wrapper">
    <a-modal
      :title="null"
      :visible="visible"
      :footer="null"
      :centered="true"
      :get-container="() => $refs.modalw"
      :width="500"
      wrap-class-name="modal-content"
      @cancel="handleCancel"
    >
      <div>
        <div class="title">
          申请免费试用<br>
          开启智慧零售新篇章
        </div>
        <a-form class="form" :form="form" @submit="handleSubmit">
          <a-form-item>
            <a-input
              v-decorator="[
                'address',
                { rules: [{ required: true, message: '请输入所在城市!' }] },
              ]"
              placeholder="请输入所在城市"
            />
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="['name', { rules: [{ required: true, message: '请输入姓名!' }] }]"
              placeholder="输入联系人姓名"
            />
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="['phone', { rules: [{
                required: true,
                message: '请输入手机号!'
              }, {
                validator: checktelphone,
              }] }]"
              placeholder="输入手机号码"
            />
          </a-form-item>
          <a-form-item>
            <a-input-search
              v-decorator="['verifyCode', { rules: [{ required: true, message: '请输入短信验证码!' }] }]"
              placeholder="短信验证码"
              size="large"
              @search="sendMessage"
            >
              <a-button slot="enterButton" :disabled="!isShowGetCode">
                <template v-if="isShowGetCode">获取验证码</template>
                <template v-else>{{ countdown }}s后可重试</template>
              </a-button>
            </a-input-search>
          </a-form-item>
          <a-form-item>
            <div class="statement">
              隐私声明：<br>
              接受通过此手机接收相关的产品信息和咨询，汇通数科不会将您的信息进行商用或者透露给第三方，请放心填写。
            </div>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" html-type="submit" class="submit-btn">
              提交申请
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
    <div id="captcha" />
  </div>
</template>

<script>
import { informationCollection, sendSmsCaptcha } from '@/apis/index'
export default {
  name: 'TryModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    infoSources: {
      type: String,
      default: '微商城'
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      countdown: 60,
      timer: '',
      isShowGetCode: true,
      captchaIns: null,
      params: null
    }
  },
  mounted() {
    this.getCode()
  },
  methods: {
    checktelphone(rule, value, callback) {
      const reg = /^1[3456789]\d{9}$/
      if (value && !(reg.test(value))) {
        callback('请输入正确的手机号码！')
      } else {
        callback()
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = {
            infoSources: this.infoSources,
            officialWebsiteEntrance: 'PC',
            address: values.address,
            name: values.name,
            phone: values.phone,
            verifyCode: values.verifyCode
          }
          informationCollection(params).then(res => {
            this.$message.success({
              content: '感谢您的信息提交，我们将会有专员与您联系~',
              duration: 1
            })
            this.captchaIns.refresh()
            this.form.resetFields()
            this.$emit('cancel', false)
          }).catch(err => {
            this.$message.error(err)
            this.captchaIns.refresh()
          })
        }
      })
    },
    handleCancel(e) {
      this.$emit('cancel', false)
    },
    sendMessage() {
      this.form.validateFields(['phone'], (errors, values) => {
        if (!errors) {
          this.params = values
          this.captchaIns.popUp()
        }
      })
    },
    countDown() {
      const self = this
      this.timer = setInterval(() => {
        self.countdown--
        if (self.countdown === 0) {
          clearInterval(self.timer)
          self.countdown = 60
          self.isShowGetCode = true
          self.captchaIns.refresh()
        }
      }, 1000)
    },
    getCode() {
      const that = this
      // eslint-disable-next-line no-undef
      initNECaptcha && initNECaptcha({
        element: '#captcha',
        captchaId: '6c0483e901164a789d9d13f0291ba257',
        mode: 'popup',
        width: '320px',
        // enableClose: true,
        onClose: function() {
          // 弹出关闭结束后将会触发该函数
        },
        onVerify: function(err, data) {
          if (err) return
          that.params.pictureCode = data.validate
          sendSmsCaptcha(that.params).then(data => {
            that.countDown()
            that.isShowGetCode = false
          }).catch(err => {
            that.$message.error(err)
            that.captchaIns.refresh()
          })
        }
      }, function(instance) {
        // 初始化成功后得到验证实例instance，可以调用实例的方法
        that.captchaIns = instance
      }, function(err) {
        console.log(err)
        // 初始化失败后触发该函数，err对象描述当前错误信息
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .title {
    width: 198px;
    height: 56px;
    font-size: 22px;
    font-weight: 600;
    color: #222;
    line-height: 28px;
    margin-left: 36px;
    margin-bottom: 20px;
  }
  .form {
    width: 380px;
    margin: 0 auto;
  }
  /deep/ .ant-select {
    font-size: 16px;
  }
  /deep/ .ant-select-selection--single {
    height: 42px;
  }
  /deep/ .ant-select-selection__rendered {
    line-height: 42px;
  }
  /deep/ .ant-input {
    height: 42px;
  }
  /deep/ .ant-btn-lg {
    height: 42px;
  }
  /deep/ .ant-btn-lg {
    background: #F9FBFD;
  }
  /deep/ .submit-btn {
    width: 380px;
    height: 50px;
    border-radius: 4px;
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
  }
  .statement {
    font-size: 14px;
    font-weight: 400;
    color: #8B8FA1;
    line-height: 22px;
  }
  .count-down {
    background: #F9FBFD;
    color: rgba(0, 0, 0, 0.65);
    width: 112px;
  }
</style>
